// extracted by mini-css-extract-plugin
module.exports = {"advert":"eYH7d","advertImg":"_36Ljo"};